import Menu from '@mui/material/Menu';
import { ICellRendererParams } from 'ag-grid-community';
import React from 'react';
import { OptionsData } from '../../../models/grid.model';
import { MenuItemRenderer } from './actionsMenuItemRendrer';
import { SettingsVertiIcon, SettingsWhiteVerticalIcon } from '../../../icon';

interface Props extends ICellRendererParams {
    MenuData: OptionsData[];
    IsWhiteIcon?: boolean;
}

export const ActionsRenderer = (props: Props) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <span onClick={handleClick} className='c-pointer'>
                {!!props.IsWhiteIcon ? <SettingsWhiteVerticalIcon /> : <SettingsVertiIcon />}
            </span>
            {!!props.MenuData.filter(x => !x.Hide)?.length && <Menu
                id="customized-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                classes={{ paper: "gridactionsmenu bg-color-grid-options-menu" }}
                className={"dialogue-shadow"}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
            >
                <MenuItemRenderer MenuData={props.MenuData} OnClick={handleClose} key={props.data.Id} />
            </Menu>
            }
        </>)
};
